import { createContext, useContext, useState } from "react"
import { Box, IconButton, Modal, Paper, Stack, Typography, useTheme } from "@mui/material"
import { Close } from "@mui/icons-material"

import ContactForm from "./ContactForm"

const EnquireContext = createContext()

export const useEnquire = () => useContext(EnquireContext)

const makeStyles = (theme) => ({
    paper: {
        width: `calc(100% - ${theme.spacing(2)} * 2)`,
        maxWidth: "520px",
        maxHeight: "90vh",
        overflow: "auto",
        p: 3,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        borderRadius: 2,
    },
    header: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
        mb: 1,
    },
})

const EnquireModal = ({ children }) => {
    const theme = useTheme()
    const styles = makeStyles(theme)

    const [enquire, setEnquire] = useState(null)

    const open = (details = {}) => setEnquire(details)
    const close = () => setEnquire(null)

    const carName = enquire?.carName
    const defaultMessage = carName
        ? `Hi, I'm interested in hiring the ${carName}. Please let me know the next steps.`
        : ""

    return (
        <EnquireContext.Provider value={open}>
            {children}
            <Modal open={enquire !== null} onClose={close}>
                <Paper sx={styles.paper}>
                    <Box sx={styles.header}>
                        <Stack spacing={0.5}>
                            <Typography variant="h5" fontWeight="bold">
                                {carName ? `Enquire about ${carName}` : "Enquire now"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Tell us a bit about yourself and we&apos;ll get you on the road.
                            </Typography>
                        </Stack>
                        <IconButton onClick={close} aria-label="Close enquire form" size="small">
                            <Close />
                        </IconButton>
                    </Box>
                    {enquire !== null && (
                        <ContactForm
                            key={carName || "general"}
                            defaultMessage={defaultMessage}
                            carName={carName || ""}
                            submitLabel="Send enquiry"
                            onSuccess={close}
                        />
                    )}
                </Paper>
            </Modal>
        </EnquireContext.Provider>
    )
}

export default EnquireModal
